const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@(henkel\.com)$/
export function isCorpEmail(email) {
  return pattern.test(email)
}
